import { VideoUploadPage } from "./VideoUploadPage";
export default VideoUploadPage;
